import Button from 'components/Button'
import styles from './Success.sass'
import React from 'react'
import link from 'infra/link'

export default function CheckoutSuccess() {
  return (
    <div className={styles.root}>
      <div className={styles.logo}>
        <img
          src={require('assets/logos/logo_taxfyle-blue.svg')}
          alt="taxfyle logo."
        />
      </div>

      <div className={styles.content}>
        <img
          className={styles.illustration}
          src={require('assets/images/img_manage-billing.svg')}
          alt="Two hands exchanging a coin"
        />
        <div className={styles.title}>
          Thank you! The payment has been successfully processed!
        </div>
        <div className={styles.description}>
          You can check the job status on the dashboard. If you have any
          questions, please reach out to our support team.
        </div>
        <div className={styles.aciton}>
          <Button to={link.jobs()} type="primary">
            Go to Dashboard
          </Button>
        </div>
      </div>
    </div>
  )
}
